import { render, staticRenderFns } from "./settlement-consignee-node.vue?vue&type=template&id=68335d72&scoped=true"
import script from "./settlement-consignee-node.vue?vue&type=script&lang=js"
export * from "./settlement-consignee-node.vue?vue&type=script&lang=js"
import style0 from "./settlement-consignee-node.vue?vue&type=style&index=0&id=68335d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68335d72",
  null
  
)

export default component.exports